import { CSSProperties, ReactNode } from 'react';
import { useInitializeVanillaJs } from '../compatibility/initialize-vanillajs-hook';
import { SpinnerPage } from './SpinnerPage';
import { ErrorBoundary } from '../components/ErrorBoundary/ErrorBoundary';
import { Footer } from '../components/Footer/Footer';

import '../css/vendor/FA5/css/all.min.css';
import '../css/vendor/icon.font.min.css';
import '../scss/main.scss';

type DefaultPageProps = {
  containerStyle?: CSSProperties;
  showFooter?: boolean;
  containerChildren?: ReactNode;
};

export function DefaultPage({
  containerStyle = {
    width: '100%',
    overflowX: 'hidden',
    minHeight: '600px',
  },
  containerChildren,
  showFooter = true,
}: DefaultPageProps) {
  const isLoading = useInitializeVanillaJs();

  return (
    <>
      {isLoading ? <SpinnerPage /> : <></>}
      <div
        id="MainContainer"
        className="container flex-1"
        style={containerStyle}
      >
        {containerChildren && (
          <ErrorBoundary>{containerChildren}</ErrorBoundary>
        )}
      </div>
      {showFooter && <Footer />}
    </>
  );
}

export function PageWithBlueGreyBackground(defaultProps: DefaultPageProps) {
  return (
    <DefaultPage
      containerStyle={{ backgroundColor: '#f3f5f6' }}
      {...defaultProps}
    />
  );
}

export function PageWithOverflowHidden() {
  return (
    <DefaultPage
      containerStyle={{
        width: '100%',
        overflow: 'hidden',
        background: '#f7f7f7',
      }}
    />
  );
}

export function PageWithContentMask(defaultProps: DefaultPageProps) {
  return (
    <>
      <DefaultPage {...defaultProps} />
      <div
        id="contentMask"
        style={{
          position: 'fixed',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: 9999999,
          display: 'none',
          background: 'rgba(255, 255, 255, 0)',
        }}
      />
      <div
        id="content"
        className="shrink2"
        style={{
          position: 'fixed',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: 9999999,
          display: 'none',
          background: '#ffffff',
        }}
      />
    </>
  );
}
